export enum PaymentOrigins {
    Ecommerce = 1,
    Admin = 2,
    PointOfSale = 3,
    SelfService = 4,
    MobileApp = 5
}
